<template>
    <div class="position-box">
        <div class="cotainer down-load">
          <img class="header-back" src="@/assets/icon_back.png" alt="back" @click="goBack">
          <a class="btn-box btn-and" v-show="andriod" @click="download(andriod)">
          <img class="icon" src="@/assets/anzhuo.png" alt="Android">
          <div>Android <span>{{$t('download.xz')}}</span></div>
          </a>
          <a class="btn-box" v-show="ios2" :href="ios2">
            <img class="icon" src="@/assets/pingguo.png" alt="IOS">
            <div>IOS <span>{{$t('download.xz')}}</span>(Testflight)</div>
          </a>
          <a class="btn-box" v-show="ios" style="margin-top: 30px;" :href="ios">
            <img class="icon" src="@/assets/pingguo.png" alt="IOS">
            <div>IOS <span>{{$t('download.xz')}}</span>(Signature)</div>
          </a>
          <a class="btn-box" v-show="ios_link_2" style="margin-top: 30px;" :href="ios_link_2">
            <img class="icon" src="@/assets/pingguo.png" alt="IOS">
            <div>IOS <span>{{$t('download.xz')}}</span>(Signature)</div>
          </a>
          <a class="btn-box" v-show="ios_current_link" style="margin-top: 30px;" :href="ios_current_link">
            <img class="icon" src="@/assets/pingguo.png" alt="IOS">
            <div>IOS <span>{{$t('download.xz')}}</span>(Signature)</div>
          </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'downLoad',
    data () {
        return {
          theme: false,
          andriod: '',
          ios: '',
          ios2: '',
          ios_link_2: '',
          ios_current_link: '',
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
         this.getParams()
    },
    methods: {
        goBack(){
            this.$router.push('/index')
        },
        getParams(){
            var that = this;
            this.$ajax.get('/web/getParam',{}).then((res) => {
                let resData = res.data.data;
                for(var i=0;i< resData.length; i++){
                    if(resData[i].key == 'android_link'){
                        that.andriod = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }else if(resData[i].key == 'ios_link'){
                        that.ios = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }else if(resData[i].key == 'tf_link'){
                        that.ios2 = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }else if(resData[i].key == 'ios_link_2'){
                        that.ios_link_2 = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }else if(resData[i].key == 'ios_current_link'){
                        that.ios_current_link = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }
                }

            }).catch(function(err){
                console.log(err)
            })
        },
        download(url){
            var src = url;
            var form = document.createElement('form');
            form.action = src;
            form.method = 'post';
            document.getElementsByTagName('body')[0].appendChild(form);
            form.submit();
        }
    }
}
</script>
<style scoped>
    .cotainer{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        padding-top: 3rem;
        background: url('../assets/bg.jpg') no-repeat center center!important;
        background-size: cover!important;
        overflow-y: scroll;
    }
    .header-back{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .5rem;
    }
    .btn-box{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80%;
        height: 50px;
        margin-left: 10%;
        color: #fff;
        font-size: 16px;
        background: #3381d5;
        border-radius: 16px;
    }
    .btn-and{
        margin: 30px 10%;
    }
    .btn-box .icon{
        width: 24px;
        height: 28px;
        margin-right: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/downLoad.vue